/**
 * دکمهٔ خروجیِ اکسل — مشترک برای همهٔ صفحات.
 *
 * 🐞 تا v2.102 با `window.open` باز می‌شد: بدونِ هدرِ ورود، سرور ۴۰۱ می‌داد و مرورگر
 * همان JSON را به‌شکلِ متن نشان می‌داد («یه صفحهٔ مزخرف»). حالا دانلود با کلاینتِ
 * احرازشده انجام می‌شود و نامِ فایل همان است که سرور می‌دهد.
 *
 * دو حالت:
 *   • `url` (+`params`)            → مسیرِ آمادهٔ سرور (`/api/v1/export/...`)
 *   • `rows` + `columns` + `filename` → همان جدولِ روی صفحه با قالبِ مشترکِ اکسل
 */
import React, { useState } from "react";
import { Button, Tooltip, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { downloadFile, downloadTableXlsx } from "../api/client";
import { tableToPayload } from "../utils/tableExport";

/** خطای سرور در پاسخِ blob متنِ خوانا ندارد؛ اینجا درمی‌آید. */
async function blobDetail(e, fallback) {
  try {
    const d = e?.response?.data;
    if (d && typeof d.text === "function") {
      const t = await d.text();
      try { const j = JSON.parse(t); if (typeof j.detail === "string") return j.detail; } catch { /* متنِ ساده */ }
    }
  } catch { /* بی‌خیال */ }
  return e?.response?.data?.detail || fallback;
}

export default function ExportButton({
  url, params = {}, label = "خروجی اکسل", color, icon, size,
  rows, columns, filename, title, subtitle,
}) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      if (url) {
        await downloadFile(url, `${filename || label}.xlsx`, { params });
      } else if (rows && columns) {
        const name = filename || title || label;
        const payload = tableToPayload(columns, rows, title || name);
        if (subtitle) payload.subtitle = subtitle;
        await downloadTableXlsx(payload, `${name}.xlsx`);
      } else {
        message.warning("چیزی برای خروجی نیست");
        setBusy(false);
        return;
      }
      message.success("فایلِ اکسل دانلود شد");
    } catch (e) {
      message.error(await blobDetail(e, "خطا در ساختِ خروجی"));
    }
    setBusy(false);
  };

  return (
    <Tooltip title={`دانلود ${label}`}>
      <Button size={size} icon={icon || <DownloadOutlined />} onClick={run} loading={busy}
        style={{ background: color || "#107C41", color: "white", borderColor: color || "#107C41" }}>
        {label}
      </Button>
    </Tooltip>
  );
}
